<script>
    import { navigateTo } from 'svelte-router-spa'
    import { department } from '../../store.js'

    function nxt() {
        department.set($department)
        navigateTo('symptom')
    }
</script>

<main>
    <div class="body">
        <h1>Enter the Department you belong to</h1>
        <p>Ilagay ang iyong Department</p>
        <input type="text" bind:value={$department}>

        {#if $department}
        <a class="btn btn-primary" on:click={nxt}>Next</a>
        {/if}
    </div>
</main>